import { useMediaQuery, useTheme } from '@mui/material';
const useEventDynamicFormStyles = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    return {
        innerScrollableContentContainer: {
            // height: isSmallScreen
            //   ? `calc(100dvh - (238px + 80px + 4px))`
            //   : `calc(100dvh - ${scrollableContentHeight} - ${contentContainerHeight})`,
            padding: isSmallScreen ? 1 : undefined,
            pb: !isSmallScreen ? '60px' : undefined,
            overflow: 'auto'
        }
    };
};
export default useEventDynamicFormStyles;
